<!-- user-registration.component.html -->
<div class="dialog-wrapper">
  <mat-card class="dialog-card">
    <form [formGroup]="registrationForm" class="form-content">
      <div class="text-center">
        <img width="60%" src="../../../../assets/images/ares-userlogo.png" />
        <h2 class="mt-3">Register</h2>
      </div>

      <mat-form-field style="width: 100%;">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" [readonly]="isRegistered" (blur)="trimName()" />
        <mat-error *ngIf="registrationForm.get('firstName')?.errors?.required">
          First name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field style="width: 100%;">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" [readonly]="isRegistered" (blur)="trimName()" />
        <mat-error *ngIf="registrationForm.get('lastName')?.errors?.required">
          Last name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field style="width: 100%;">
        <mat-label>Email</mat-label>
        <input matInput type="email"#emailInput id="emailInput" [(ngModel)]="inputText" (input)="onInputChange()"
          formControlName="email"
          [readonly]="isRegistered || isGuest || data" />
        <mat-error *ngIf="registrationForm.get('email')?.errors?.required">Email is required</mat-error>
        <mat-error *ngIf="registrationForm.get('email')?.errors?.pattern">Invalid email</mat-error>
      </mat-form-field>

      <mat-form-field style="width: 100%;">
        <mat-label>Phone Number</mat-label>
        <input matInput formControlName="phoneNumber" (keydown)="onKeyDownOfPhone($event)"
          (keyup)="onKeyUpOfPhone($event)" />
      </mat-form-field>

      <mat-form-field style="width: 100%;">
        <mat-label>Password</mat-label>
        <input type="password" matInput formControlName="password" [readonly]="isRegistered" />
        <mat-error *ngIf="registrationForm.get('password')?.errors?.required">Password is required</mat-error>
      </mat-form-field>

      <mat-form-field style="width: 100%;">
        <mat-label>Confirm Password</mat-label>
        <input type="password" matInput formControlName="confirmPassword" [readonly]="isRegistered" />
      </mat-form-field>

      <mat-form-field *ngIf="isRegistered" style="width: 100%;">
        <mat-label>6 Digit Verification Code</mat-label>
        <input type="text" matInput formControlName="otp" />
      </mat-form-field>

      <div class="form-group button-group">
        <button [disabled]="loading" class="btn btn-primary" (click)="createUser()" *ngIf="!isRegistered">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Register
        </button>

        <button [disabled]="loading" class="btn btn-primary" (click)="resendOtp()" *ngIf="isRegistered">
          Resend Code
        </button>

        <button [disabled]="loading" class="btn btn-primary" (click)="verifyUser()" *ngIf="isRegistered">
          Verify
        </button>
      </div>
    </form>
  </mat-card>
</div>